<mat-card class="default has-progress-bar" *ngIf="intake">
  <mat-progress-bar
    [mode]="refreshInProgress ? 'indeterminate' : 'determinate'"
  ></mat-progress-bar>
  <mat-card-title>
    <span>{{ 'patient-details.timeline-card.title' | translate }}</span>
  </mat-card-title>
  <mat-card-content>
    <div class="timeline">
      <div
        class="timeline-item"
        *ngIf="intake.statusTransitions && intake.statusTransitions['P']"
      >
        <div class="timeline-badge">
          <mat-icon color="primary" class="icon-badge">done</mat-icon>
        </div>
        <div class="timeline-body">
          <div class="timeline-body-top" fxLayout="row">
            {{ patient.fullName }}
          </div>
          <div class="timeline-body-content">
            {{ 'patient-details.timeline-card.started-intake-at' | translate }}
            {{ intake.statusTransitions['P'] | momentDateTime: 'local' }}
          </div>
        </div>
      </div>
      <div
        class="timeline-item"
        *ngFor="
          let timeline of timelines
            | slice: 0:(!expandTimeLine ? 2 : timelines.length + 2)
        "
      >
        <div class="timeline-badge">
          <mat-icon color="primary" class="icon-badge">done</mat-icon>
        </div>
        <div class="timeline-body">
          <div class="timeline-body-top" fxLayout="row">
            {{ getActorName(timeline.actor) }}
          </div>
          <div class="timeline-body-content">
            {{
              getIntakeStatusText(timeline.stage, timeline.actor.type)
                | translate
            }}
            {{ 'common.intake' | translate }} {{ 'common.at' | translate }}
            {{ timeline.created | momentDateTime: 'local' }}
          </div>
        </div>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      class="mt-5"
      *ngIf="timelines && timelines.length > 2"
    >
      <button
        mat-button
        color="primary"
        (click)="expandTimeLine = !expandTimeLine"
      >
        {{ 'common.show' | translate }}
        <ng-container *ngIf="!expandTimeLine">{{
          'common.more' | translate
        }}</ng-container>
        <ng-container *ngIf="expandTimeLine">{{
          'common.less' | translate
        }}</ng-container>
      </button>
    </div>
  </mat-card-content>
</mat-card>
